//@flow
import React from 'react';
import { Image } from 'components/atoms/image';
import { CallToAction } from 'components/atoms/callToAction';
import { RouteNames } from 'router';
import { withRouter } from 'react-router-dom';
import { RouteUtil } from 'utils/RouteUtil';
import PastEventsMobile from 'assets/images/PastEventsMobile.jpg';

const PastEventsBannerMobile = (props) => {

  const handleSeeAll = (props) => {
    RouteUtil.setRouteChange(props, RouteNames.pastMusicEvents);
  };

  return (
    <div className={'main-section'}>
      <h2 className={'headingClassName'}> Past Events </h2>
      <div className={'foundation-mob'}>
        <Image
          src={PastEventsMobile}
          alt={'FoundationPic'}
          className={'foundation-image'}
        />
      </div>
      <div className="learn-more">
        <CallToAction
          onClick={() => handleSeeAll(props)}
          text={'SEE ALL'}
          mode={'dark'}
          type={'link'}
          size={'small'}
        />
      </div>
    </div>
  );
};
export default withRouter(PastEventsBannerMobile);